import { Grid, Paper } from "@mui/material";
import { styled } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getClaims, getPreAuthHistory } from "../../action";
import TableN from "../../reusableComponents/components/generics/TableN";
import "../../styles/theme.scss";
const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function PreAuthHistory({ id }) {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [preAuthData, setPreAuthData] = useState();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState();
  const token = localStorage.getItem("token");
  const [startCursors, setStartCursors] = useState();
  const userData = useSelector((state) => state.profileReducer);
  const userId = SignInSuccess?.profileReducer?.currentUserResponseData?.id;
  const adminData = SignInSuccess?.fosaReducer?.AdminIdData;
  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];

  useEffect(() => {
    dispatch(getPreAuthHistory(id));
  }, [id]);

  console.log(SignInSuccess?.fosaReducer?.getPreAuthHistoryData, "preauthhid");

  useEffect(() => {
    if (
      healthData?.location?.parent?.uuid &&
      healthData?.location?.uuid &&
      healthData?.uuid
    ) {
      let params = buildQueryParams({
        // filters: filter,
        filters: {},
        pageSize,
        beforeCursor: endCursors,
        afterCursor: startCursors,
        orderBy: ["-dateClaimed"],
        healthFacility_Location_Parent_Uuid: healthData?.location?.parent?.uuid,
        healthFacility_Location_Uuid: healthData?.location?.uuid,
        healthFacility_Uuid: healthData?.uuid,
      });
      if (
        healthData?.location?.parent?.uuid ||
        healthData?.location?.uuid ||
        healthData?.uuid
      ) {
        dispatch(getClaims(params));
      }
    }
  }, [
    healthData,
    healthData?.location?.parent?.uuid,
    healthData?.location?.uuid,
    healthData?.uuid,
    page,
    pageSize,
  ]);
  const buildQueryParams = (state) => {
    let params = [];

    // Ensure state.filters exists before trying to access its properties
    if (state.filters) {
      params = Object.keys(state.filters)
        .filter((f) => !!state.filters[f]["filter"])
        .map((f) => state.filters[f]["filter"]);
    }

    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.healthFacility_Location_Parent_Uuid) {
      params.push(
        `healthFacility_Location_Parent_Uuid: "${state.healthFacility_Location_Parent_Uuid}"`
      );
    }
    if (!!state.healthFacility_Location_Uuid) {
      params.push(
        `healthFacility_Location_Uuid: "${state.healthFacility_Location_Uuid}"`
      );
    }
    if (!!state.healthFacility_Uuid) {
      params.push(`healthFacility_Uuid: "${state.healthFacility_Uuid}"`);
    }

    return params;
  };

  useEffect(() => {
    if (SignInSuccess?.fosaReducer?.getPreAuthHistoryData) {
      setPreAuthData(SignInSuccess?.fosaReducer?.getPreAuthHistoryData);
      setPageInfo(
        SignInSuccess?.fosaReducer?.PreAuthHistoryPageInfo.totalCount
      );
      setStartCursors(
        SignInSuccess?.fosaReducer?.PreAuthHistoryPageInfo?.endCursor
      );
      setEndCursors(
        SignInSuccess?.fosaReducer?.PreAuthHistoryPageInfo?.startCursor
      );
    }
  }, [SignInSuccess?.fosaReducer?.getPreAuthHistoryData]);
  const claimApprovalStatusMapping = {
    "-1": t("Rejected"),
    1: t("Created"),
    2: t("Waiting for Approval"),
    3: t("Rework"),
    4: t("Approved"),
  };
  const statusStyles = {
    "-1": { color: "red" },
    1: { color: "blue" },
    2: { color: "gray" },
    3: { color: "orange" },
    4: { color: "green" },
  };
  const headers = () => {
    var h = [
      t("Request No..."),
      t("Approval Request Date"),
      t(" Approved By"),
      t(" Approval Date"),
      t("Status"),
      t("Remark"),
    ];
    return h;
  };

  const itemFormatters = () => {
    var row = [
      (preAuthData) => (!!preAuthData.code ? preAuthData.code : ""),
      (preAuthData) => {
        const dateValidFrom = new Date(preAuthData.dateCreated);
        return dateValidFrom.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
      },
      (preAuthData) =>
        !!preAuthData.userCreated ? preAuthData.userCreated?.username : "",
      (preAuthData) => {
        const dateValidFrom = new Date(preAuthData.dateUpdated);
        return dateValidFrom.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
      },
      (policyHolderData) => {
        const statusValue = policyHolderData.status;
        const statusText =
          claimApprovalStatusMapping[statusValue] || t("Unknown Status");
        const statusStyle = statusStyles[statusValue] || {};
        return <span style={statusStyle}>{statusText}</span>;
      },
      (policyHolderData) => {
        const comments = policyHolderData.comments;
        return <span>{comments}</span>;
      },
    ];

    return row;
  };
  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setEndCursors(null);
    setStartCursors(null);
    setPage(0);
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };
  const handleRowDoubleClick = (rowData) => {
    console.log(rowData, "rowData");
    navigate(`/fosa/preautharizationForm/:id=${rowData.id}`);
  };

  const handleOpen = () => {};

  return (
    <Grid style={{ margin: "10px" }}>
      <TableN
        headers={headers()}
        itemFormatters={itemFormatters()}
        items={preAuthData ? preAuthData : []}
        withSelection={"single"}
        withPagination={true}
        rowsPerPageOptions={[10, 50, 100]}
        defaultPageSize={5}
        page={page}
        pageSize={pageSize}
        count={pageInfo}
        onChangePage={(event, newPage) => {
          setPage(newPage);
          handleNavigation(newPage > page ? "forward" : "backward");
        }}
        onChangeRowsPerPage={handleRowsPerPageChange}
        onDoubleClick={handleRowDoubleClick}
      />
    </Grid>
  );
}

export default PreAuthHistory;
